import axios from 'axios'

import { attachToken, handleError } from './axiosInterceptors'

const API_BASE = '/api/v1'

export const httpClient = axios.create({
    baseURL: API_BASE,
    headers: { 'Content-type': 'application/json' },
})

httpClient.interceptors.request.use(
    attachToken(() => localStorage.getItem('authorized_token')),
    Promise.reject,
)
httpClient.interceptors.response.use((res) => res, handleError)

export const uploadClient = axios.create({
    baseURL: API_BASE,
    headers: { 'Content-Type': 'multipart/form-data' },
})

uploadClient.interceptors.request.use(
    attachToken(() => localStorage.getItem('authorized_token')),
    Promise.reject,
)
uploadClient.interceptors.response.use((res) => res, handleError)
